// React context object for the login form state.
// Kept separate from LoginFormContext.tsx (provider) and hooks/useLoginFormContext.ts (consumer)
// to satisfy react-refresh/only-export-components: no component in this file.
import { createContext } from "react";
import type { LoginFlowReturn } from "../types";

export const LoginFormContext = createContext<LoginFlowReturn | null>(null);
